import mitt, { Emitter, EventType, Handler } from 'mitt'

// 扩展Emitter类型，添加asyncOn方法
// interface ExtendedEmitter<T = Record<EventType, unknown>> extends Emitter<T> {
//   once: <T = any>(eventName: EventType) => Promise<T>
// }
// 1. 定义你的事件类型映射
type Events = {
  [key: string]: any
}
type CustomEmitter<T extends Record<EventType, unknown>> = Emitter<T> & {
  once<K extends keyof T>(eventName: K): Promise<T[K]>
}
export const bus = mitt<Events>() as CustomEmitter<Events>
bus.once = (eventName) => {
  return new Promise((resolve) => {
    const handler: Handler<Events[typeof eventName]> = (payload) => {
      // 触发后立即注销，防止内存泄漏
      bus.off(eventName, handler)
      resolve(payload)
    }
    bus.on(eventName, handler)
  })
}
